// Временный доступ сопровождения (data-model.md, access.support_grants; FR-022 – FR-023г).
import { z } from '../kernel/zod.ts';
import { IdSchema, PersonRefSchema, TimestampSchema } from '../kernel/common.ts';

/** действует → истёк | прекращён. */
export const supportGrantStates = ['active', 'expired', 'revoked'] as const;
export const SupportGrantStateSchema = z.enum(supportGrantStates);
export type SupportGrantState = (typeof supportGrantStates)[number];

export const SUPPORT_GRANT_MAX_HOURS = 24;

export const SupportGrantSchema = z.object({
  id: IdSchema,
  /** Кому выдан. */
  supportUser: PersonRefSchema,
  /** Кто выдал — администратор клиента. */
  grantedBy: PersonRefSchema,
  reason: z.string(),
  validFrom: TimestampSchema,
  validUntil: TimestampSchema,
  revokedAt: TimestampSchema.optional(),
  revokedBy: PersonRefSchema.optional(),
  state: SupportGrantStateSchema,
});
export type SupportGrant = z.infer<typeof SupportGrantSchema>;
